export const HEROKU_API_BASE_URL = "https://digital-navigator.herokuapp.com";
export const HEROKU_API_BASE_URL_DEV = "http://localhost:8080";
export class ChartApiEndpoints {
  getChartEndpoint = `${HEROKU_API_BASE_URL}/chart`;
  fetchContentEndpoint = (code: string) =>
    `${HEROKU_API_BASE_URL}/chart/content/${code}`;
  getRemoteConfigEndpoint = `${HEROKU_API_BASE_URL}/remote-config`;
}
